// api/services/activity.ts
import { handleRequest } from '@/api';

export interface ActiveUser {
    id: number;
    email: string;
    entity_type: string;
    entity_name: string;
    last_seen: string;
}

export const getActiveUsers = (): Promise<ActiveUser[]> => handleRequest<ActiveUser[]>('get', '/active-users');
